import { PrevArticle, SetArticleQuantityBodyV2, useCheckoutContext } from '@zooplus/checkout-state';

import { ARTICLE_TYPE, CART_VERSION, CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';
import { isObjectNotNullOrEmpty } from '@utilities/utils';

import useCartTracking from './use-adobe-tracking/use-cart-tracking';

export const useRestoreArticle = () => {
  const {
    cartVersion,
    prevArticle,
    setPrevArticle = () => {},
    setSavingsPlanArticle = () => {},
    setArticleQuantity = () => {},
    setLoyaltyManagementArticle = () => {},
  } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  const { trackReAddArticleEvent } = useCartTracking();

  return () => {
    if (isObjectNotNullOrEmpty(prevArticle)) {
      const { articleId, articleType, offerIds = [] } = prevArticle as PrevArticle;

      const payload = {
        articleId: Number(articleId),
        quantity: 1,
      };

      if (cartVersion === CART_VERSION.V2 && offerIds?.length) {
        (payload as SetArticleQuantityBodyV2).offerIds = offerIds;
      }

      trackReAddArticleEvent(Number(articleId), articleType);

      switch (articleType) {
        case ARTICLE_TYPE.SAVINGS_PLAN:
          setSavingsPlanArticle(payload);
          break;
        case ARTICLE_TYPE.LOYALTY_MANAGEMENT:
          setLoyaltyManagementArticle(articleId);
          break;
        default:
          setArticleQuantity(payload);
          break;
      }

      setPrevArticle({} as PrevArticle);
    }
  };
};
